import React from 'react';
import { Container } from '@material-ui/core';
import BasicTabs from '../components/Tabs';
import { connect } from 'react-redux'
import { loadData } from '../components/thunks';
import { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import {useParams} from "react-router-dom";
import {useState} from "react";


const Search = ({isLoading, data, startLoadingData, errorMessage }) => {

    let params = useParams();
    const [corpus, setCorpus] = useState(params.corpus);

    const checkCorpus = (corpusParam, str) => {
        if (corpusParam === 'petka') {
            return !(str.slice(0,3) === 'vuk')
        } else if (corpusParam === 'punco') {
            return !(str === '001 predislovie - sbornik 18f')
        } else  {
            return !(str === '001 predislovie - sbornik 18f')
        }

    }


    useEffect(() => {
        let corpusParam = params.corpus;
      if (data.length < 1 || checkCorpus(corpusParam, data[0]['text'])) {
          setCorpus(corpusParam)
        startLoadingData(corpusParam)
      }
     }, [params.corpus, corpus, data, startLoadingData]  );

     function handleClick(e) {
      e.preventDefault()
      localStorage.clear();
      window.location.reload();
    
     }

     const content = <React.Fragment>
     <Container maxWidth="md">

    {isLoading ? <Stack><Alert severity="info">Loading data...       <CircularProgress size={20} />  </Alert></Stack> : <div> <BasicTabs data={data} /></div>} 

    <button onClick={(e) => handleClick(e)} style={{marginTop: '10px'}} > Reload data</button>
    <div color='#1976d2' style={{ margin: 5 }}>(reloads data for updates - recommended once a week)</div>
    

    </Container>
  </React.Fragment>

  return ( <>
    {content}
    </>
  );
};

const mapStateToProps = state => ({

  isLoading: state.isLoading,
  data: state.data,
  errorMessage: state.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  startLoadingData: (corpus) => dispatch(loadData(corpus))
})

export default connect(mapStateToProps, mapDispatchToProps)(Search);